/* =============================================================================
   DTF Printer USA — Custom Mega Menu JS
   Keyboard navigation, touch support, outside-click close
   ============================================================================= */

(function () {
    'use strict';

    var NAV_SELECTOR = '.gm-main';
    var ITEM_SELECTOR = '.gm-item';
    var PANEL_SELECTOR = '.gm-panel';
    var OPEN_CLASS = 'gm-open';
    var INSTALLED_CLASS = 'gm-menu-installed';

    function init() {
        var nav = document.querySelector(NAV_SELECTOR);
        if (!nav) return;

        var items = nav.querySelectorAll(':scope > .gm-navrow > ' + ITEM_SELECTOR);
        var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

        // Mark as installed (triggers CSS to hide old nav)
        nav.classList.add(INSTALLED_CLASS);

        // Also mark the hdt-navigation element if it exists
        var oldNav = document.querySelector('.hdt-navigation');
        if (oldNav) {
            oldNav.classList.add(INSTALLED_CLASS);
        }

        // ---- Touch devices: tap to toggle instead of hover ----
        if (isTouchDevice) {
            items.forEach(function (item) {
                var panel = item.querySelector(PANEL_SELECTOR);
                if (!panel) return;

                var link = item.querySelector(':scope > a');
                if (!link) return;

                link.addEventListener('click', function (e) {
                    // If panel is already open, follow the link
                    if (item.classList.contains(OPEN_CLASS)) return;

                    e.preventDefault();
                    e.stopPropagation();

                    // Close all other panels and open this one
                    openItem(item, items);
                });
            });
        }

        // ---- Close panel when clicking outside ----
        document.addEventListener('click', function (e) {
            if (!nav.contains(e.target)) {
                closeAll(items);
            }
        });

        // ---- Keyboard navigation ----
        nav.addEventListener('keydown', function (e) {
            var key = e.key;

            if (key === 'Escape') {
                closeAll(items);
                // Return focus to the nav item that was active
                var activeItem = nav.querySelector('.' + OPEN_CLASS + ' > a');
                if (activeItem) activeItem.focus();
                closeAll(items);
                return;
            }

            // Arrow Left / Right to move between top-level items
            var itemsArray = Array.from(items);
            var currentItem = e.target.closest(ITEM_SELECTOR);
            if (!currentItem) return;

            var idx = itemsArray.indexOf(currentItem);
            if (idx === -1) return;

            if (key === 'ArrowRight') {
                e.preventDefault();
                var nextIdx = (idx + 1) % itemsArray.length;
                var nextLink = itemsArray[nextIdx].querySelector(':scope > a');
                if (nextLink) nextLink.focus();
                closeAll(items);
                if (itemsArray[nextIdx].querySelector(PANEL_SELECTOR)) {
                    openItem(itemsArray[nextIdx], items);
                }
            }

            if (key === 'ArrowLeft') {
                e.preventDefault();
                var prevIdx = (idx - 1 + itemsArray.length) % itemsArray.length;
                var prevLink = itemsArray[prevIdx].querySelector(':scope > a');
                if (prevLink) prevLink.focus();
                closeAll(items);
                if (itemsArray[prevIdx].querySelector(PANEL_SELECTOR)) {
                    openItem(itemsArray[prevIdx], items);
                }
            }

            // ArrowDown opens the panel
            if (key === 'ArrowDown') {
                var panel = currentItem.querySelector(PANEL_SELECTOR);
                if (panel) {
                    e.preventDefault();
                    openItem(currentItem, items);
                    // Focus first link in panel
                    var firstPanelLink = panel.querySelector('a');
                    if (firstPanelLink) firstPanelLink.focus();
                }
            }
        });

        // ---- Enter/Space on nav items with panels ----
        items.forEach(function (item) {
            var link = item.querySelector(':scope > a');
            var panel = item.querySelector(PANEL_SELECTOR);
            if (!link || !panel) return;

            link.addEventListener('keydown', function (e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    if (!item.classList.contains(OPEN_CLASS)) {
                        e.preventDefault();
                        openItem(item, items);
                        var firstPanelLink = panel.querySelector('a');
                        if (firstPanelLink) firstPanelLink.focus();
                    }
                }
            });
        });

        // ---- Close when focus leaves the item ----
        items.forEach(function (item) {
            item.addEventListener('focusout', function (e) {
                if (!item.contains(e.relatedTarget)) {
                    item.classList.remove(OPEN_CLASS);
                    var link = item.querySelector(':scope > a');
                    if (link && link.hasAttribute('aria-expanded')) {
                        link.setAttribute('aria-expanded', 'false');
                    }
                }
            });

            item.addEventListener('mouseleave', function () {
                item.classList.remove(OPEN_CLASS);
                var link = item.querySelector(':scope > a');
                if (link && link.hasAttribute('aria-expanded')) {
                    link.setAttribute('aria-expanded', 'false');
                }
            });

            item.addEventListener('mouseenter', function () {
                var panel = item.querySelector(PANEL_SELECTOR);
                if (panel) {
                    var link = item.querySelector(':scope > a');
                    if (link && link.hasAttribute('aria-expanded')) {
                        link.setAttribute('aria-expanded', 'true');
                    }
                }
            });
        });
    }

    function openItem(item, items) {
        closeAll(items);
        item.classList.add(OPEN_CLASS);
        var link = item.querySelector(':scope > a');
        if (link && link.hasAttribute('aria-expanded')) {
            link.setAttribute('aria-expanded', 'true');
        }
    }

    function closeAll(items) {
        items.forEach(function (item) {
            item.classList.remove(OPEN_CLASS);
            var link = item.querySelector(':scope > a');
            if (link && link.hasAttribute('aria-expanded')) {
                link.setAttribute('aria-expanded', 'false');
            }
        });
    }

    // Globo menu cards store prices as static HTML. Replace them with the
    // product's current first available variant so the menu cannot drift.
    var productCache = {};

    function money(cents) {
        return '$' + (cents / 100).toFixed(2);
    }

    function handleFromHref(href) {
        var match = String(href || '').match(/\/products\/([^/?#]+)/);
        return match ? decodeURIComponent(match[1]) : '';
    }

    function loadProduct(handle) {
        if (!productCache[handle]) {
            productCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', {
                credentials: 'same-origin'
            }).then(function (response) {
                if (response.ok) return response.json();
                // Old menu links redirect (for example 24x328 film -> 23.6x300).
                return fetch('/products/' + encodeURIComponent(handle), {
                    credentials: 'same-origin',
                    redirect: 'follow'
                }).then(function (page) {
                    var next = handleFromHref(page.url);
                    if (!next || next === handle) return null;
                    return loadProduct(next);
                });
            }).catch(function () {
                return null;
            });
        }
        return productCache[handle];
    }

    function variantToShow(product) {
        var variants = product.variants || [];
        for (var i = 0; i < variants.length; i++) {
            if (variants[i].available) return variants[i];
        }
        return variants[0] || null;
    }

    function syncPriceCard(link) {
        var handle = handleFromHref(link.getAttribute('href'));
        var priceEl = link.querySelector('.gm-price');
        if (!handle || !priceEl || priceEl.getAttribute('data-gm-synced') === '1') return;
        priceEl.setAttribute('data-gm-synced', '1');

        loadProduct(handle).then(function (product) {
            if (!product) {
                priceEl.removeAttribute('data-gm-synced');
                return;
            }
            var variant = variantToShow(product);
            if (!variant) return;

            priceEl.textContent = money(variant.price);
            var oldEl = link.querySelector('.gm-old-price');
            if (variant.compare_at_price && variant.compare_at_price > variant.price) {
                if (!oldEl) {
                    oldEl = document.createElement('span');
                    oldEl.className = 'gm-old-price';
                    priceEl.insertAdjacentElement('afterend', oldEl);
                }
                oldEl.textContent = money(variant.compare_at_price);
            } else if (oldEl) {
                oldEl.remove();
            }
        });
    }

    function syncMenuPrices() {
        var links = document.querySelectorAll('a[href*="/products/"]');
        for (var i = 0; i < links.length; i++) {
            if (links[i].querySelector('.gm-price')) syncPriceCard(links[i]);
        }
    }

    function watchMenuPrices() {
        syncMenuPrices();
        if (!window.MutationObserver || !document.body) return;
        var pending = false;
        var observer = new MutationObserver(function () {
            if (pending) return;
            pending = true;
            window.setTimeout(function () {
                pending = false;
                syncMenuPrices();
            }, 200);
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }

    // Initialize
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            init();
            watchMenuPrices();
        });
    } else {
        init();
        watchMenuPrices();
    }
})();
